import createRequest from '@/utils/request/main'

const request = createRequest(`${process.env.VUE_APP_BASE_API || ''}/scpcm`) // 生产环境

// 行业列表
export function findIndustryList() {
  return request.post('industry/findIndustryList', {})
}
// 管理模式
export function findPageList(page, pageSize, date) {
  return request.post('projectManage/findPageList?page=' + page + '&pageSize=' + pageSize, date)
}
// 新建项目(敏捷)
export function savePro(date) {
  return request.post('project/savePro', date)
}
// 版本信息
export function versionLists(date) {
  return request.post('projectVersion/findAll', date)
}
// 版本新增、编辑
export function saveVersion(date) {
  return request.post('projectVersion/saveVersion', date)
}
// 任务模式
export function taskPageList(page, pageSize, date) {
  return request.post('task/findPageList?page=' + page + '&pageSize=' + pageSize, date)
}

// 敏捷项目信息
export function getAgileProjectInformation(date) {
  return request.post('replay/getAgileProjectInformation', date)
}

// 敏捷项目版本信息
export function getAgileProjectVersionInformation(date) {
  return request.post('replay/getAgileProjectVersionInformation', date)
}

// 敏捷评选
export function getVersionSelectionData(date) {
  return request.post('replay/getVersionSelectionData', date)
}

// 敏捷评选
export function getEvaluate(date) {
  return request.post('pcmProjectEvaluate/getEvaluate', date)
}

// 敏捷点赞评价
export function saveEvaluate(date) {
  return request.post('pcmProjectEvaluate/saveEvaluate', date)
}

// 敏捷点赞标签列表
export function getEvaluateLabel() {
  return request.post('replay/getEvaluateLabel', {})
}

// 敏捷总结
export function searchProjectFeedback(page, pageSize, date) {
  return request.post('projectFeedback/searchProjectFeedback?page=' + page + '&pageSize=' + pageSize, date)
}

// 敏捷问题反馈保存
export function saveProjectFeedback(date) {
  return request.post('projectFeedback/saveProjectFeedback', date)
}

// 敏捷问题反馈详情
export function getProjectFeedbackDetail(date) {
  return request.post('projectFeedback/getProjectFeedbackDetail', date)
}

// 保存用户指数
export function getUsersOfProject(date) {
  return request.post('project/getUsersOfProject', date)
}

// 敏捷人员情况统计
export function getAgileProjectVersionUsersSituation(date) {
  return request.post('replay/getAgileProjectVersionUsersSituation', date)
}

// 敏捷反馈问题讨论列表
export function searchProjectFeedbackDiscussion(page, pageSize, date) {
  return request.post('projectFeedback/searchProjectFeedbackDiscussion?page=' + page + '&pageSize=' + pageSize, date)
}

// 敏捷反馈问题讨论
export function addProjectFeedbackDiscussion(date) {
  return request.post('projectFeedback/addProjectFeedbackDiscussion', date)
}

// 敏捷任务情况统计
export function getAgileProjectVersionTasksSituation(date) {
  return request.post('replay/getAgileProjectVersionTasksSituation', date)
}

// 敏捷指数情况统计
export function getAgileProjectVersionIndexSituation(date) {
  return request.post('replay/getAgileProjectVersionIndexSituation', date)
}

// 查询用户指数
export function searchProjectIndex(date) {
  return request.post('projectIndex/searchProjectIndex', date)
}

// 保存用户指数
export function saveProjectIndex(date) {
  return request.post('projectIndex/saveProjectIndex', date)
}

// 删除版本
export function deleteVersion(date) {
  return request.post('projectVersion/deleteVersion', date)
}

